var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footBox"},[_vm._v(" 开发单位：山东中飞科技有限公司 "),_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v(" 鲁ICP备16022226号 ")])])
}]

export { render, staticRenderFns }